import { cn } from '@/lib/utils'
import { MarkLarge } from '@/components/generals/logos'

type WordmarkProps = {
    className?: string
    markClassName?: string
    textClassName?: string
}

/**
 * The full lockup: the mark plus "Fun" set in the sans and "nel" in the
 * italic display serif, following the same split-accent pattern as the
 * original wordmark.
 */
export const Wordmark = ({ className, markClassName, textClassName }: WordmarkProps) => {
    return (
        <span className={cn('inline-flex items-center gap-2.5 text-white', className)}>
            <MarkLarge
                aria-hidden='true'
                className={cn('size-7 shrink-0', markClassName)}
            />

            <span className={cn('text-2xl leading-none font-medium tracking-[-0.04em]', textClassName)}>
                Fun

                <span className='serif-accent'>
                    nel
                </span>
            </span>
        </span>
    )
}
